var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4335_23256)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04305 17.0625H8.95695C7.22568 17.0625 5.86889 17.0625 4.81028 16.9202C3.72673 16.7745 2.87171 16.4705 2.20061 15.7994C1.5295 15.1283 1.22549 14.2733 1.07981 13.1897C0.937485 12.1311 0.937493 10.7743 0.9375 9.04305V8.95695C0.937493 7.22565 0.937485 5.8689 1.07981 4.81028C1.22549 3.72675 1.5295 2.87167 2.20061 2.20057C2.87171 1.52947 3.72673 1.2255 4.81028 1.07977C5.86889 0.937499 7.22567 0.9375 8.95695 0.9375H9.04305C10.7743 0.9375 12.1311 0.937499 13.1897 1.07977C14.2732 1.2255 15.1283 1.52947 15.7994 2.20057C16.4705 2.87167 16.7745 3.72675 16.9202 4.81028C17.0625 5.8689 17.0625 7.22565 17.0625 8.95695V9.04305C17.0625 10.7743 17.0625 12.1311 16.9202 13.1897C16.7745 14.2733 16.4705 15.1283 15.7994 15.7994C15.1283 16.4705 14.2732 16.7745 13.1897 16.9202C12.1311 17.0625 10.7743 17.0625 9.04305 17.0625ZM2.9961 15.0039C3.42334 15.4311 4.00138 15.6763 4.96019 15.8052C5.93517 15.9363 7.21633 15.9375 9 15.9375C10.7837 15.9375 12.0648 15.9363 13.0398 15.8052C13.9986 15.6763 14.5766 15.4311 15.0039 15.0039C15.4312 14.5767 15.6764 13.9986 15.8052 13.0398C15.9363 12.0648 15.9375 10.7837 15.9375 9C15.9375 7.21635 15.9363 5.9352 15.8052 4.9602C15.6764 4.0014 15.4312 3.42338 15.0039 2.9961C14.5766 2.56883 13.9986 2.32365 13.0398 2.1948C12.0648 2.0637 10.7837 2.0625 9 2.0625C7.21633 2.0625 5.93517 2.0637 4.96019 2.1948C4.00138 2.32365 3.42334 2.56883 2.9961 2.9961C2.56886 3.42338 2.32369 4.0014 2.19478 4.9602C2.06369 5.9352 2.0625 7.21635 2.0625 9C2.0625 10.7837 2.06369 12.0648 2.19478 13.0398C2.32369 13.9986 2.56886 14.5767 2.9961 15.0039Z",
    fill: "#0F1A1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7L8.375 10.6667L6.5 9",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4335_23256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttending);
export default __webpack_public_path__ + "static/media/attending.d88b7e4f0632f77f61bf82192b747b55.svg";
export { ForwardRef as ReactComponent };